import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';

function ProtectedRoute({ config }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedIn, isInitializing } = useAuth();

  useEffect(() => {
    if (!isInitializing && !loggedIn) {
      navigate(`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`, { replace: true });
    }
  }, [loggedIn, isInitializing, navigate, location]);

  if (isInitializing) {
    return null;
  }

  if (!loggedIn) {
    return null;
  }

  return <Outlet />;
}

export default ProtectedRoute;